// The generated-types facade — THE contract, for TypeScript consumers.
//
// Re-exports the CRM contract's public surface under its EXISTING names, with
// the types and schemas sourced from the forge-generated client
// (src/gen/client.ts — generated from backend/crm-api/openapi, the same
// document the Kotlin server, the Rust CLI and backend/internal-clients-crm are
// generated from). src/index.ts exports this module and nothing else, so every
// `@crm/shared` import site in crm/ui reads the generated contract under the
// names it always used.
//
// Three kinds of export live here:
//
//  1. GENERATED — `export const X = gen.YSchema; export type X = gen.Y;`
//     The generated names follow the document's resource-plural convention
//     (`PartnersItem`, `DealsCreate`); the facade maps them back to the
//     contract's names (`Partner`, `DealCreate`). The doc's `XxxsItem` is the
//     wire LIST-ITEM shape, so both the contract's base name (`Deal`) and its
//     `…ListItem` name map to the same generated schema — the base name was a
//     hand-written building block narrower than anything the API ever returns.
//  2. COMPOSED — a generated schema with the contract's hand-written
//     cross-field rules re-attached: `gen.DealsCreateSchema.superRefine(
//     dealCreateRules)`. The rules are named exports of inputs.ts (JSON Schema
//     cannot express them; they are behavior, not shape).
//  3. HAND-WRITTEN KEEPERS — the pure helpers (split/convert arithmetic, the
//     deal and invoice predicates, `listEnvelope`), the contract constants
//     (DEAL_SORT_FIELDS, CLOSED_WON_STATES), and the scalar vocabulary
//     (`Uuid`, `Money`, `IsoDate`, …) — none of which are API types. Their
//     homes (common.ts, deal.ts, invoice.ts, fx.ts, implementationFee.ts,
//     inputs.ts) hold nothing else: every schema that used to sit beside them
//     is generated.
//
// The cross-field rules in group 2 are the one part of the contract the
// document cannot carry. JSON Schema says what a field is; it cannot say
// "start_date_latest may not fall before start_date_earliest" or "a
// flat_per_period term line carries an amount and counts the period". Those
// rules stay hand-written in inputs.ts, typed structurally so they compose onto
// the generated schemas, and they are re-attached here.
//
// Deliberately absent: `ProblemDetails`/`ProblemCode`/`FieldError` — the error
// envelope is `ErrorResponse` (`ErrorResponseV2` + `DialAiErrorCode`), exported
// below — and any registry of resources: the OpenAPI document is the registry
// now, crm/mcp derives its tools straight from it, and the Kotlin server emits
// `/api/describe` from its own declarations.
import * as gen from "./gen/client.js";
import { dealCreateRules, dealUpdateRules, invoiceLineCreateRules, invoiceLineUpdateRules, prepaidEntitlementCreateRules, prepaidEntitlementUpdateRules, termLineCreateRules, termLinePreviewRules, termLineUpdateRules, } from "./inputs.js";
// ---------------------------------------------------------------------------
// Hand-written keepers: scalar vocabulary, envelope, helpers, constants.
// ---------------------------------------------------------------------------
export { convertMinor, FxApplied, FxDisplay, FxDisplayStatus } from "./fx.js";
export { Instant, IsoDate, IsoMonth, IsoWeek, listEnvelope, Money, Percent, RecordMeta, SortDirection, SortSpec, splitMinor, Uuid, } from "./common.js";
export { CLOSED_WON_STATES, CountryCode, DEAL_SORT_FIELDS, dealHasCoordinates, dealHasLocation, dealInheritsTerms, } from "./deal.js";
export { isIssued } from "./invoice.js";
export { isResolvedImplementationFeeRow, } from "./implementationFee.js";
export { customerLocationProblem, invoiceLineShapeProblem, termLineShapeProblem, } from "./inputs.js";
// ---------------------------------------------------------------------------
// Errors — the V2 envelope (replaces problem+json at cutover).
// ---------------------------------------------------------------------------
/**
 * The whole envelope, discriminator included. Parse a failure body with THIS:
 * `ErrorResponseV2` describes the variant's own fields and rejects the
 * `version` tag that rides beside them.
 */
export const ErrorResponse = gen.ErrorResponseSchema;
export const ErrorResponseV2 = gen.ErrorResponseV2Schema;
export const DialAiErrorCode = gen.DialAiErrorCodeSchema;
// ---------------------------------------------------------------------------
// Session
// ---------------------------------------------------------------------------
export const SessionInfo = gen.SessionInfoSchema;
export const ActorType = gen.ActorTypeSchema;
// ---------------------------------------------------------------------------
// Partners
// ---------------------------------------------------------------------------
export const Partner = gen.PartnersItemSchema;
export const PartnerCreate = gen.PartnersCreateSchema;
export const PartnerUpdate = gen.PartnersUpdateSchema;
// ---------------------------------------------------------------------------
// Agreements, terms, implementation-fee tiers
// ---------------------------------------------------------------------------
export const Agreement = gen.AgreementsItemSchema;
export const AgreementCreate = gen.AgreementsCreateSchema;
export const AgreementUpdate = gen.AgreementsUpdateSchema;
export const AgreementWithTerms = gen.AgreementsDetailSchema;
export const AgreementTerm = gen.AgreementTermsItemSchema;
export const AgreementTermCreate = gen.AgreementTermsCreateSchema;
export const AgreementTermUpdate = gen.AgreementTermsUpdateSchema;
export const AgreementTermWithTiers = gen.AgreementsDetailTermsItemSchema;
export const AgreementImplFeeTier = gen.AgreementImplFeeTiersItemSchema;
export const AgreementImplFeeTierCreate = gen.AgreementImplFeeTiersCreateSchema;
export const AgreementImplFeeTierUpdate = gen.AgreementImplFeeTiersUpdateSchema;
// ---------------------------------------------------------------------------
// Deals
// ---------------------------------------------------------------------------
export const DealState = gen.DealStateSchema;
export const Collection = gen.CollectionSchema;
export const InvoiceRecipient = gen.InvoiceRecipientSchema;
/** The doc's `DealsItem` is the wire list-row; `Deal` (the hand-written base)
 * is a structural subset of it, so both names map here. */
export const Deal = gen.DealsItemSchema;
export const DealListItem = gen.DealsItemSchema;
export const DealCreate = gen.DealsCreateSchema.superRefine(dealCreateRules);
export const DealUpdate = gen.DealsUpdateSchema.superRefine(dealUpdateRules);
// ---------------------------------------------------------------------------
// Term lines — a deal's interpretation, one clause at a time
//
// Each line says which facts it reads (selector), how many units they carry
// (quantity), what a unit is worth (price), whose money that is (share) and
// which invoice it lands on (period). The five clauses are the whole model:
// a flat subscription and a per-minute overage are the same object with
// different expressions in them.
// ---------------------------------------------------------------------------
export const BillingTiming = gen.BillingTimingSchema;
export const Cadence = gen.CadenceSchema;
export const TermLineKind = gen.TermLineKindSchema;
export const PriceSource = gen.PriceSourceSchema;
export const ShareKind = gen.ShareKindSchema;
export const TermLineMilestone = gen.TermLineMilestoneSchema;
export const TermLine = gen.TermLinesItemSchema;
export const TermLineCreate = gen.TermLinesCreateSchema.superRefine(termLineCreateRules);
export const TermLineUpdate = gen.TermLinesUpdateSchema.superRefine(termLineUpdateRules);
/**
 * A whole line, unsaved. What "Try it" sends: the evaluator runs it over the
 * period and returns the statement line it would produce, and nothing is
 * written.
 */
export const TermLinePreview = gen.TermLinePreviewSchema.superRefine(termLinePreviewRules);
/** Append-only and hashed: an issued invoice pins the revision it billed. */
export const TermLineRevision = gen.TermLineRevisionsItemSchema;
// ---------------------------------------------------------------------------
// Charges — what a term line produces, and what state it is in
// ---------------------------------------------------------------------------
export const ChargeStatus = gen.ChargeStatusSchema;
export const StatementLineStatus = gen.StatementLineStatusSchema;
export const MilestoneState = gen.MilestoneStateSchema;
export const SplitSource = gen.SplitSourceSchema;
export const CostBillingMode = gen.CostBillingModeSchema;
// Where a line's figure comes from. Published because four report shapes carry
// it — the statement, the month close, the bill run and the invoice draft —
// and a screen that reads one of them and re-declares the vocabulary is a
// screen that can disagree with the other three.
export const FigureSource = gen.FigureSourceSchema;
export const DerivedFigureIssue = gen.DerivedFigureIssueSchema;
/** Why a fact carried no figure. Counted, never dropped — see `DealStatement`. */
export const UnpricedReason = gen.UnpricedReasonSchema;
// ---------------------------------------------------------------------------
// Facts — every input, measured or typed, with a source
//
// A fact is a fact whether a machine measured it or a person typed it, and
// both enter through the same audited ingest batch. That is what makes "Record
// a fact" one form for any fact kind: the SPA posts a one-row batch with
// `source: "person"`.
// ---------------------------------------------------------------------------
export const FactSource = gen.FactSourceSchema;
export const IngestBatchResult = gen.IngestBatchResultSchema;
export const DealFactKind = gen.DealFactKindSchema;
export const DealFact = gen.DealFactsItemSchema;
/** One row of an ingest batch. A correction is a re-ingest of the same key. */
export const DealFactRow = gen.DealFactRowSchema;
export const IngestDealFactsRequest = gen.IngestDealFactsRequestSchema;
export const ProviderCostFact = gen.ProviderCostFactsItemSchema;
export const ProviderCostFactRow = gen.ProviderCostFactRowSchema;
export const IngestProviderCostFactsRequest = gen.IngestProviderCostFactsRequestSchema;
// ---------------------------------------------------------------------------
// Prepaid entitlements — a pool, the window it covers, the lines it covers
// ---------------------------------------------------------------------------
export const CarryOver = gen.CarryOverSchema;
export const PrepaidEntitlement = gen.PrepaidEntitlementsItemSchema;
export const PrepaidEntitlementCreate = gen.PrepaidEntitlementsCreateSchema.superRefine(prepaidEntitlementCreateRules);
export const PrepaidEntitlementUpdate = gen.PrepaidEntitlementsUpdateSchema.superRefine(prepaidEntitlementUpdateRules);
// ---------------------------------------------------------------------------
// The statement — the interpretation run over one period
//
// A statement is not stored. It is `interpretDeal` over the deal's term lines
// and the facts of the period, so deleting every cache brings the same figures
// back. An invoice is a statement a person issued, frozen.
// ---------------------------------------------------------------------------
export const DealStatement = gen.DealStatementSchema;
export const DealStatementLine = gen.DealStatementLineSchema;
export const PreviewDealStatementRequest = gen.PreviewDealStatementRequestSchema;
// ---------------------------------------------------------------------------
// Invoices & lines
// ---------------------------------------------------------------------------
export const InvoiceStatus = gen.InvoiceStatusSchema;
export const InvoiceLineCategory = gen.InvoiceLineCategorySchema;
export const InvoiceLineSourceKind = gen.InvoiceLineSourceKindSchema;
export const InvoiceListItem = gen.InvoicesItemSchema;
export const InvoiceCreate = gen.InvoicesCreateSchema;
export const InvoiceUpdate = gen.InvoicesUpdateSchema;
export const InvoiceLineListItem = gen.InvoiceLinesItemSchema;
export const InvoiceLineCreate = gen.InvoiceLinesCreateSchema.superRefine(invoiceLineCreateRules);
export const InvoiceLineUpdate = gen.InvoiceLinesUpdateSchema.superRefine(invoiceLineUpdateRules);
export const InvoiceIssue = gen.IssueInvoiceRequestSchema;
export const InvoiceIssueResult = gen.IssueInvoiceResponseSchema;
// What issuing did to one derived line on the document: it evaluated the
// period and wrote the figure, or the figure was already there and it wrote
// nothing. A freeze is the moment a growing figure stops moving, and nothing
// else on the screen says when it did.
export const InvoiceFreezeAction = gen.InvoiceFreezeActionSchema;
/** A draft's line, re-evaluated on every read: a draft is always current. */
export const InvoiceDraftLine = gen.InvoiceDraftLineSchema;
export const InvoiceLineOrphanReason = gen.InvoiceLineOrphanReasonSchema;
export const InvoiceLineOrphan = gen.InvoiceLineOrphanSchema;
export const CreateInvoiceDraftRequest = gen.CreateInvoiceDraftRequestSchema;
export const CreateInvoiceDraftResponse = gen.CreateInvoiceDraftResponseSchema;
export const RefreshInvoiceLinesResponse = gen.RefreshInvoiceLinesResponseSchema;
// ---------------------------------------------------------------------------
// FX rates
// ---------------------------------------------------------------------------
export const Currency = gen.CurrencySchema;
export const FxRate = gen.FxRatesItemSchema;
export const FxRateCreate = gen.FxRatesCreateSchema;
export const FxRateUpdate = gen.FxRatesUpdateSchema;
// ---------------------------------------------------------------------------
// The ledger — one beancount document per currency, and no FX in it
// ---------------------------------------------------------------------------
export const LedgerReport = gen.LedgerReportSchema;
// ---------------------------------------------------------------------------
// Reports
// ---------------------------------------------------------------------------
export const ReportScope = gen.ReportScopeSchema;
export const PipelineReport = gen.PipelineReportSchema;
export const ProjectionReport = gen.ProjectionReportSchema;
export const ProjectionSettings = gen.ProjectionSettingsSchema;
export const ProjectionSettingsUpdate = gen.ProjectionSettingsUpdateSchema;
// Sales trends: the pipeline over time from the deals' own estimates, and one
// deal's history (its stages, imported ones included, and its edits).
export const SalesReport = gen.SalesReportSchema;
export const ClosingPace = gen.ClosingPaceSchema;
export const DealHistory = gen.DealHistorySchema;
export const PartnerRollupReport = gen.PartnerRollupReportSchema;
export const RevenueByRegionGroupBy = gen.RevenueByRegionGroupBySchema;
export const RevenueByRegionReport = gen.RevenueByRegionReportSchema;
export const ImplFeeUnresolvedReason = gen.ImplFeeUnresolvedReasonSchema;
export const ImplementationFeeReport = gen.ImplementationFeeReportSchema;
export const CalendarEventKind = gen.CalendarEventKindSchema;
export const CalendarReport = gen.CalendarReportSchema;
export const RunwayReport = gen.RunwayReportSchema;
export const TrendsReport = gen.TrendsReportSchema;
export const TrendsRow = gen.TrendsReportRowsItemSchema;
export const MarginReport = gen.MarginReportSchema;
export const MarginTrendReport = gen.MarginTrendReportSchema;
export const MonthCloseNeed = gen.MonthCloseNeedSchema;
export const MonthCloseReport = gen.MonthCloseReportSchema;
export const BillRunReport = gen.BillRunReportSchema;
export const BillingLineupReport = gen.BillingLineupReportSchema;
export const DriftReport = gen.DriftReportSchema;
// ---------------------------------------------------------------------------
// Usage cost: the explorer's contract
//
// The cost screens (docs/crm-cost-explorer.md) read these and nothing else.
// `UsageCostAnswer` is deliberately absent: the 200 and the 202 are two
// declared arms of ONE operation, and which arm came back is the HTTP status,
// not a field on a body. The api layer maps the status to the schema.
// ---------------------------------------------------------------------------
// Who an invoice is sent to and who signs it off, on a partner or on a deal.
export const BillingContact = gen.BillingContactsItemSchema;
export const BillingContactCreate = gen.BillingContactsCreateSchema;
export const BillingContactUpdate = gen.BillingContactsUpdateSchema;
export const BillingContactRole = gen.BillingContactRoleSchema;
export const TenantBinding = gen.TenantBindingsItemSchema;
export const UsageCostGroupBy = gen.UsageCostGroupBySchema;
export const UsageCostSort = gen.UsageCostSortSchema;
export const UsageCostSource = gen.UsageCostSourceSchema;
export const UsageCostGroup = gen.UsageCostGroupSchema;
export const UsageCostProvenance = gen.UsageCostProvenanceSchema;
export const UsageCostResponse = gen.UsageCostResponseSchema;
export const UsageCostPending = gen.UsageCostPendingSchema;
export const UsageRateGap = gen.UsageRateGapSchema;
export const StartUsageJobRequest = gen.StartUsageJobRequestSchema;
export const UsageJob = gen.UsageJobSchema;
export const UsageJobKind = gen.UsageJobKindSchema;
export const UsageJobStatus = gen.UsageJobStatusSchema;
export const UsageTrendGroupBy = gen.UsageTrendGroupBySchema;
export const UsageTrendPoint = gen.UsageTrendPointSchema;
export const UsageTrendSeries = gen.UsageTrendSeriesSchema;
export const UsageTrendResponse = gen.UsageTrendResponseSchema;
// ---------------------------------------------------------------------------
// Notes, and finding things.
//
// Notes are the one prose corpus here: what was SAID about a deal, as against
// what it bills. Global search is the one read that crosses kinds — and it
// keeps them apart rather than ranking them against each other, because a deal
// matched on its customer's name and a note matched on a paragraph are not
// comparable.
// ---------------------------------------------------------------------------
export const NoteKind = gen.NoteKindSchema;
export const NoteSource = gen.NoteSourceSchema;
export const NoteEmbeddingState = gen.NoteEmbeddingStateSchema;
/** A note as a LIST returns it: everything but the body. */
export const NoteListItem = gen.NotesItemSchema;
/** One note in full, which is what a read of a single note and every write answer with. */
export const Note = gen.NotesDetailSchema;
export const NoteCreate = gen.NotesCreateSchema;
export const NoteUpdate = gen.NotesUpdateSchema;
export const NoteSearchResults = gen.NoteSearchResultsSchema;
export const NoteSearchHit = gen.NoteSearchResultsItemSchema;
export const NoteReembedScope = gen.NoteReembedScopeSchema;
export const NotesReembedResult = gen.NotesReembedResultSchema;
export const SearchHitKind = gen.SearchHitKindSchema;
export const SearchHit = gen.SearchHitSchema;
export const SearchResultsGroup = gen.SearchResultsGroupSchema;
export const SearchResults = gen.SearchResultsSchema;
// ---------------------------------------------------------------------------
// Rates and expressions: the rules behind those figures.
//
// The usage-cost block above is what a month COST; this is why. A rate prices a
// unit, and an expression says which facts a term line's selector matches and
// how many units each one carries. The expression language is shared: the
// selector and the quantity of every term line are written in it.
// ---------------------------------------------------------------------------
export const RateUnit = gen.RateUnitSchema;
export const ProviderRate = gen.ProviderRatesItemSchema;
export const MeterSource = gen.MeterSourceSchema;
export const MeterUnit = gen.MeterUnitSchema;
export const MeterExpr = gen.MeterExprSchema;
export const MeterFieldName = gen.MeterFieldNameSchema;
export const MeterUndefinedCounts = gen.MeterUndefinedCountsSchema;
//# sourceMappingURL=facade.js.map